import {
  AfterViewInit,
  Component,
  ElementRef, HostListener,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
  Signal,
  viewChild
} from '@angular/core';
import {RendererStore} from "../../store/Renderer.store";
import {RenderingService} from "../../service/rendering.service";
import {SceneObjectManagerService} from "../../service/scene-object.manager.service";
import {EnvironmentService} from "../../service/environment.service";
import {MaterialService} from "../../service/material/material.service";

@Component({
  selector: 'app-canvas',
  standalone: true,
  imports: [],
  templateUrl: './canvas.component.html',
  styleUrl: './canvas.component.scss'
})
export class CanvasComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly rendererStore = inject(RendererStore);
  private readonly renderingService = inject(RenderingService);
  private readonly sceneObjectManager = inject(SceneObjectManagerService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly materialService = inject(MaterialService);

  private readonly canvas: Signal<ElementRef> = viewChild('canvasElement');

  private readonly ngZone = inject(NgZone);

  ngOnInit() {
    //run outside of angular zone
    this.ngZone.runOutsideAngular(() => {
      this.rendererStore.initializeCanvas(this.canvas().nativeElement);
    });
  }

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        this.canvas().nativeElement.height = newHeight;
        this.rendererStore.resizeCanvas(document.body.clientWidth, newHeight)

      }
    });

    this.resizeObserver.observe(document.body);
  }

  @HostListener('document:scroll', ['$event'])
  private onEvent(event: Event) { this.cycledRender() }

  private cycledRender() {
    const cycled = this.rendererStore.renderingStrategy === 'cycled';
    if(cycled) { this.renderingService.animateOnce() }
  }


  ngOnDestroy() {
    this.renderingService.stopAnimate();
    //this.sizeHandlerService.removeCanvasSizeHandling(this.canvas().nativeElement);

    // Katkaise ResizeObserver
    this.resizeObserver?.disconnect();

    // Ympärstö tarvii renderöijän ja rendreöijä tarvii canvaksen joten tämäkin pitää poistaa
    this.environmentService.clearEnvironment();

    // Materiaalit käyttävät ympääristöä joten ne pitää tyhjentää kun ympäristö tyhjennetään
    this.materialService.disposeAllMaterials();

    // Toistaiseksi viewPort ei huolehdi omien objectien poistamisesta, joten poistetaan kun canvas tuhotaan.
    this.sceneObjectManager.removeAllObjects();

    this.rendererStore.removeCanvas();
  }

}
